<p class="form-headernotification" *ngIf="!_sessionService.hasRole(RoleType.ADMIN)  && _sessionService.isAccountType('SYSTEM')">
  Your role does not allow for saving settings changes on this screen.
</p>
<form [formGroup]="form" style="height:100%" [ngClass]="(!_sessionService.hasRole(RoleType.ADMIN) && _sessionService.isAccountType('SYSTEM'))? 'colorsectiondisabled': ''">
  <div class="color-section">
    <div class="color-wrapper">
      <div class="color-viewer"
        [style.background]="_brand.baseColor"
        [cpToggle]="true"
        cpPosition="bottom"
        [cpOKButton]="true"
        cpOKButtonText="Submit"
        (colorPickerSelect)="colorChange('baseColor', $event)"
        cpAlphaChannel="disabled"
        [(colorPicker)]="_brand.baseColor"
        [cpPositionOffset]="'50%'"
        [cpPositionRelativeToArrow]="true"
        [cpSaveClickOutside]="false">
      </div>
      <div>
        <div class="color-title">Base Color</div>
        <div class="color-value">{{_brand.baseColor}}</div>
      </div>
      <input hidden formControlName="baseColor" [value]="_brand.baseColor">
    </div>
    <div class="color-wrapper">
      <div class="color-viewer"
        [style.background]="_brand.highlightColor"
        [cpToggle]="true"
        cpPosition="bottom"
        [cpOKButton]="true"
        cpOKButtonText="Submit"
        (colorPickerSelect)="colorChange('highlightColor', $event)"
        cpAlphaChannel="disabled"
        [(colorPicker)]="_brand.highlightColor"
        [cpPositionOffset]="'50%'"
        [cpPositionRelativeToArrow]="true"
        [cpSaveClickOutside]="false">
      </div>
      <div>
        <div class="color-title">Highlight Color</div>
        <div class="color-value">{{_brand.highlightColor}}</div>
      </div>
      <input hidden formControlName="highlightColor" [value]="_brand.highlightColor">
    </div>
    <div class="color-wrapper">
      <div class="color-viewer"
        [style.background]="_brand.textBackgroundColor"
        [cpToggle]="true"
        cpPosition="bottom"
        [cpOKButton]="true"
        cpOKButtonText="Submit"
        (colorPickerSelect)="colorChange('textBackgroundColor', $event)"
        cpAlphaChannel="disabled"
        [(colorPicker)]="_brand.textBackgroundColor"
        [cpPositionOffset]="'50%'"
        [cpPositionRelativeToArrow]="true"
        [cpSaveClickOutside]="false">
      </div>
      <div>
        <div class="color-title">Text Background Color</div>
        <div class="color-value">{{_brand.textBackgroundColor}}</div>
      </div>
      <input hidden formControlName="textBackgroundColor" [value]="_brand.textBackgroundColor">
    </div>
  </div>
  <div class="report-section">
    <div class="form-header">
      Report images should have a resolution of 2550x3300 (8.5" x 11" at 300dpi). Photoshop templates to assist in creating the images can be accessed <a href="/assets/report/report-templates.zip" target="_blank">here</a>. Uploaded files should be .JPG or .PNG.
    </div>
    <div class="report-preview-wrapper">
      <div class="report-tile">
        <img *ngIf='_brand.documentTitlePage' id="titlePageImage" class="sample-report" [class.error]="form.controls.documentTitlePage?.errors?.invalid" [src]='_brand.documentTitlePage'>
        <div class="upload-image-mask" (click)="titlePageInput.click()">
          <mat-icon svgIcon="cw:action_screenshot"></mat-icon>
          UPLOAD IMAGE
        </div>
        <input hidden type="file" #titlePageInput accept="image/jpeg, image/png" (change)="imageChange('Title', $event);" />
        <mat-error *ngIf="form.controls.documentTitlePage?.errors?.invalid">The file submitted is not an accepted file type. Please use either PNG or JPG.</mat-error>
      </div>
      <div class="report-tile">
        <img *ngIf='_brand.documentPageHeader' id="pageHeaderImage" class="sample-report" [class.error]="form.controls.documentPageHeader?.errors?.invalid" [src]='_brand.documentPageHeader'>
        <div class="upload-image-mask" (click)="contentPageInput.click()">
          <mat-icon svgIcon="cw:action_screenshot"></mat-icon>
          UPLOAD IMAGE
        </div>
        <input hidden type="file" #contentPageInput accept="image/jpeg, image/png" (change)="imageChange('Content', $event);" />
        <mat-error *ngIf="form.controls.documentPageHeader?.errors?.invalid">The file submitted is not an accepted file type. Please use either PNG or JPG</mat-error>
      </div>
    </div>
    <div class="revert-button-wrapper">
      <button [disabled]="!_brand?.id" mat-raised-button type="button" color="primary" (click)="revertToDefault()">Revert to Default</button>
    </div>
  </div>
</form>
  